module.exports = __webpack_public_path__ + "img/banner_training_m.dfb44816.png";